export default "__VITE_ASSET__D7EWSxN0__"